import { z } from 'zod';
import { lessonSchema } from './lesson.js';

export const learningPathLessonSchema = z.object({
  order: z.number().int(),
  lessonId: z.string(),
  lesson: lessonSchema,
});
export type LearningPathLesson = z.infer<typeof learningPathLessonSchema>;

export const learningPathSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type LearningPath = z.infer<typeof learningPathSchema>;

export const learningPathWithLessonsSchema = learningPathSchema.extend({
  learningPathLessons: z.array(learningPathLessonSchema),
});
export type LearningPathWithLessons = z.infer<typeof learningPathWithLessonsSchema>;

export const createLearningPathOptionsSchema = z.object({
  name: z.string(),
  lessons: z.array(
    z.object({
      lessonId: z.string(),
      order: z.number().int(),
    }),
  ),
});
export type CreateLearningPathOptions = z.infer<typeof createLearningPathOptionsSchema>;

export const updateLearningPathOptionsSchema = z.object({
  name: z.string(),
  lessons: z.array(
    z.object({
      lessonId: z.string(),
      order: z.number().int(),
    }),
  ),
});

export type UpdateLearningPathOptions = z.infer<typeof updateLearningPathOptionsSchema>;
export const GetLearningPathResultsSchema = z.object({
  learningPaths: z.array(learningPathWithLessonsSchema),
});
export type GetLearningPathResults = z.infer<typeof GetLearningPathResultsSchema>;

export const learningPathNamesSchema = z.enum([
  'Regular',
  'Regular - extended',
  'Beginner',
  'Beginner - extended',
  'Middle School',
  'Intermediate',
  'Fluency',
  'Fluency (3)',
  'Fluency (1)',
  'Fluency (2)',
  'Practice (Zoom)',
  'Practice (Google Meet)',
  'Diagnostic',
  'Diagnostic w/ Practice (Zoom)',
  'Diagnostic w/ Practice (Google Meet)',
  'Makeup Diagnostic',
  'Read Aloud',
  'Assigned GLA',
]);
export const LearningPathNames = learningPathNamesSchema.enum;
export type LearningPathNames = z.infer<typeof learningPathNamesSchema>;
export const learningPathNamesArray = learningPathNamesSchema.options;

export const interventionLearningPathNames: string[] = [
  LearningPathNames.Regular,
  LearningPathNames['Regular - extended'],
  LearningPathNames.Beginner,
  LearningPathNames['Beginner - extended'],
  LearningPathNames['Middle School'],
  LearningPathNames.Intermediate,
  LearningPathNames['Fluency (3)'],
  LearningPathNames['Fluency (1)'],
  LearningPathNames['Fluency (2)'],
  LearningPathNames['Read Aloud'],
];

export const practiceLearningPathNames: string[] = [
  LearningPathNames['Practice (Google Meet)'],
  LearningPathNames['Practice (Zoom)'],
];

export const diagnosticLearningPathNames: string[] = [
  LearningPathNames.Diagnostic,
  LearningPathNames['Diagnostic w/ Practice (Google Meet)'],
  LearningPathNames['Diagnostic w/ Practice (Zoom)'],
  LearningPathNames['Makeup Diagnostic'],
];
